/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiChannelBindings } from '../asyncapi/models/AaiChannelBindings';
import { AaiChannelBindingsDefinition } from '../asyncapi/models/AaiChannelBindingsDefinition';
import { AaiChannelItem } from '../asyncapi/models/AaiChannelItem';
import { AaiCorrelationId } from '../asyncapi/models/AaiCorrelationId';
import { AaiHeaderItem } from '../asyncapi/models/AaiHeaderItem';
import { AaiMessage } from '../asyncapi/models/AaiMessage';
import { AaiMessageBindings } from '../asyncapi/models/AaiMessageBindings';
import { AaiMessageBindingsDefinition } from '../asyncapi/models/AaiMessageBindingsDefinition';
import { AaiMessageTrait } from '../asyncapi/models/AaiMessageTrait';
import { AaiMessageTraitDefinition } from '../asyncapi/models/AaiMessageTraitDefinition';
import { AaiOperationBindings } from '../asyncapi/models/AaiOperationBindings';
import { AaiOperationBindingsDefinition } from '../asyncapi/models/AaiOperationBindingsDefinition';
import { AaiOperationTrait } from '../asyncapi/models/AaiOperationTrait';
import { AaiOperationTraitDefinition } from '../asyncapi/models/AaiOperationTraitDefinition';
import { AaiParameter } from '../asyncapi/models/AaiParameter';
import { AaiServer } from '../asyncapi/models/AaiServer';
import { AaiServerBindings } from '../asyncapi/models/AaiServerBindings';
import { AaiServerBindingsDefinition } from '../asyncapi/models/AaiServerBindingsDefinition';
import { Aai20NodeFactory } from '../asyncapi/v2/models/Aai20NodeFactory';
import { IAai20Visitor } from '../asyncapi/v2/visitors/IAai20Visitor';
import { Node } from '../core/models/Node';
import { AuthorizationCodeOAuthFlow } from '../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../core/models/common/Components';
import { IDefinition } from '../core/models/common/IDefinition';
import { ImplicitOAuthFlow } from '../core/models/common/ImplicitOAuthFlow';
import { OAuthFlows } from '../core/models/common/OAuthFlows';
import { Operation } from '../core/models/common/Operation';
import { Parameter } from '../core/models/common/Parameter';
import { PasswordOAuthFlow } from '../core/models/common/PasswordOAuthFlow';
import { Schema } from '../core/models/common/Schema';
import { SecurityRequirement } from '../core/models/common/SecurityRequirement';
import { SecurityScheme } from '../core/models/common/SecurityScheme';
import { Server } from '../core/models/common/Server';
import { ServerVariable } from '../core/models/common/ServerVariable';
import { ModelClonerVisitor } from './ModelClonerVisitor';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ModelClonerVisitor
 */
export class Aai20ModelClonerVisitor extends ModelClonerVisitor implements IAai20Visitor {
    static factory : Aai20NodeFactory; public static factory_$LI$() : Aai20NodeFactory { if(Aai20ModelClonerVisitor.factory == null) Aai20ModelClonerVisitor.factory = new Aai20NodeFactory(); return Aai20ModelClonerVisitor.factory; };

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createOperation(node.parent(), node.getType());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createParameter((<Node><any>node).parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createParameter(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitSchemaDefinition(node : IDefinition) {
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchema(io.apicurio.datamodels.core.models.common.Schema)
     * @param {Schema} node
     */
    public visitSchema(node : Schema) {
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     * @param {SecurityRequirement} node
     */
    public visitSecurityRequirement(node : SecurityRequirement) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createSecurityRequirement(node.parent());
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createSecurityScheme(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitComponents(io.apicurio.datamodels.core.models.common.Components)
     * @param {Components} node
     */
    public visitComponents(node : Components) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createComponents(node.parent());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServer(io.apicurio.datamodels.core.models.common.Server)
     * @param {Server} node
     */
    public visitServer(node : Server) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createServer(node.parent(), (<AaiServer>node).getName());
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServerVariable(io.apicurio.datamodels.core.models.common.ServerVariable)
     * @param {ServerVariable} node
     */
    public visitServerVariable(node : ServerVariable) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createServerVariable(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitAuthorizationCodeOAuthFlow(io.apicurio.datamodels.core.models.common.AuthorizationCodeOAuthFlow)
     * @param {AuthorizationCodeOAuthFlow} node
     */
    public visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createOAuthFlows(node.parent()).createAuthorizationCodeOAuthFlow();
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitChannelItem(io.apicurio.datamodels.asyncapi.models.AaiChannelItem)
     * @param {AaiChannelItem} node
     */
    public visitChannelItem(node : AaiChannelItem) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createChannelItem(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitClientCredentialsOAuthFlow(io.apicurio.datamodels.core.models.common.ClientCredentialsOAuthFlow)
     * @param {ClientCredentialsOAuthFlow} node
     */
    public visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createOAuthFlows(node.parent()).createClientCredentialsOAuthFlow();
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitCorrelationId(io.apicurio.datamodels.asyncapi.models.AaiCorrelationId)
     * @param {AaiCorrelationId} node
     */
    public visitCorrelationId(node : AaiCorrelationId) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createCorrelationId(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitHeaderItem(io.apicurio.datamodels.asyncapi.models.AaiHeaderItem)
     * @param {AaiHeaderItem} node
     */
    public visitHeaderItem(node : AaiHeaderItem) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createHeaderItem(node.parent());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitImplicitOAuthFlow(io.apicurio.datamodels.core.models.common.ImplicitOAuthFlow)
     * @param {ImplicitOAuthFlow} node
     */
    public visitImplicitOAuthFlow(node : ImplicitOAuthFlow) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createOAuthFlows(node.parent()).createImplicitOAuthFlow();
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessage(io.apicurio.datamodels.asyncapi.models.AaiMessage)
     * @param {AaiMessage} node
     */
    public visitMessage(node : AaiMessage) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createMessage(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageTrait(io.apicurio.datamodels.asyncapi.models.AaiMessageTrait)
     * @param {AaiMessageTrait} node
     */
    public visitMessageTrait(node : AaiMessageTrait) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createMessageTrait(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageTraitDefinition(io.apicurio.datamodels.asyncapi.models.AaiMessageTraitDefinition)
     * @param {AaiMessageTraitDefinition} node
     */
    public visitMessageTraitDefinition(node : AaiMessageTraitDefinition) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createMessageTraitDefinition(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOAuthFlows(io.apicurio.datamodels.core.models.common.OAuthFlows)
     * @param {OAuthFlows} node
     */
    public visitOAuthFlows(node : OAuthFlows) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createOAuthFlows(node.parent());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationTrait(io.apicurio.datamodels.asyncapi.models.AaiOperationTrait)
     * @param {AaiOperationTrait} node
     */
    public visitOperationTrait(node : AaiOperationTrait) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createOperationTrait(node.parent(), node.getType());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationTraitDefinition(io.apicurio.datamodels.asyncapi.models.AaiOperationTraitDefinition)
     * @param {AaiOperationTraitDefinition} node
     */
    public visitOperationTraitDefinition(node : AaiOperationTraitDefinition) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createOperationTraitDefinition(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitPasswordOAuthFlow(io.apicurio.datamodels.core.models.common.PasswordOAuthFlow)
     * @param {PasswordOAuthFlow} node
     */
    public visitPasswordOAuthFlow(node : PasswordOAuthFlow) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createOAuthFlows(node.parent()).createPasswordOAuthFlow();
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitAaiParameter(io.apicurio.datamodels.asyncapi.models.AaiParameter)
     * @param {AaiParameter} node
     */
    public visitAaiParameter(node : AaiParameter) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createParameter(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitServerBindings(io.apicurio.datamodels.asyncapi.models.AaiServerBindings)
     * @param {AaiServerBindings} node
     */
    public visitServerBindings(node : AaiServerBindings) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createServerBindings(node.parent());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitServerBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiServerBindingsDefinition)
     * @param {AaiServerBindingsDefinition} node
     */
    public visitServerBindingsDefinition(node : AaiServerBindingsDefinition) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createServerBindingsDefinition(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationBindings(io.apicurio.datamodels.asyncapi.models.AaiOperationBindings)
     * @param {AaiOperationBindings} node
     */
    public visitOperationBindings(node : AaiOperationBindings) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createOperationBindings(node.parent());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiOperationBindingsDefinition)
     * @param {AaiOperationBindingsDefinition} node
     */
    public visitOperationBindingsDefinition(node : AaiOperationBindingsDefinition) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createOperationBindingsDefinition(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageBindings(io.apicurio.datamodels.asyncapi.models.AaiMessageBindings)
     * @param {AaiMessageBindings} node
     */
    public visitMessageBindings(node : AaiMessageBindings) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createMessageBindings(node.parent());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiMessageBindingsDefinition)
     * @param {AaiMessageBindingsDefinition} node
     */
    public visitMessageBindingsDefinition(node : AaiMessageBindingsDefinition) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createMessageBindingsDefinition(node.parent(), node.getName());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitChannelBindings(io.apicurio.datamodels.asyncapi.models.AaiChannelBindings)
     * @param {AaiChannelBindings} node
     */
    public visitChannelBindings(node : AaiChannelBindings) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createChannelBindings(node.parent());
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitChannelBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiChannelBindingsDefinition)
     * @param {AaiChannelBindingsDefinition} node
     */
    public visitChannelBindingsDefinition(node : AaiChannelBindingsDefinition) {
        this.__clone = Aai20ModelClonerVisitor.factory_$LI$().createChannelBindingsDefinition(node.parent(), node.getName());
    }

    constructor() {
        super();
    }
}
Aai20ModelClonerVisitor["__class"] = "io.apicurio.datamodels.cloning.Aai20ModelClonerVisitor";
Aai20ModelClonerVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor"];




